"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = require("react");

var SyncSensor_1 = require("../SyncSensor");

var util_1 = require("../util");

var faccToHoc_1 = tslib_1.__importDefault(require("../util/faccToHoc"));

var addListener = function addListener(handler) {
  return window.addEventListener('resize', handler);
};

var removeListener = function removeListener(handler) {
  return window.removeEventListener('resize', handler);
};

var onEvent = function onEvent() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};

var getInitialState = function getInitialState() {
  if (util_1.isClient) {
    return onEvent();
  } else {
    return {
      width: 1920,
      height: 1080
    };
  }
};

var WindowSizeSensor = function (_super) {
  tslib_1.__extends(WindowSizeSensor, _super);

  function WindowSizeSensor() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.initial = getInitialState();
    return _this;
  }

  WindowSizeSensor.prototype.render = function () {
    return util_1.h(SyncSensor_1.SyncSensor, tslib_1.__assign({}, this.props, {
      initial: this.initial,
      addListener: addListener,
      removeListener: removeListener,
      onEvent: onEvent
    }));
  };

  return WindowSizeSensor;
}(react_1.Component);

exports.WindowSizeSensor = WindowSizeSensor;
exports.withWindowSize = faccToHoc_1.default(WindowSizeSensor, 'windowSize');